// FeedbackPopup.jsx

import React, { useState } from 'react';
import { Box, Typography, TextField, Button, Stack } from '@mui/material';

type FeedbackType = 'like' | 'dislike' | null;

interface FeedbackPopupProps {
  messageId: string | null;
  feedbackType: FeedbackType;
  onClose: () => void;
  onSendFeedback?: (messageId: string | null, feedbackType: FeedbackType, feedbackText: string) => void;
}

const FeedbackPopup: React.FC<FeedbackPopupProps> = ({ messageId, feedbackType, onClose, onSendFeedback }) => {
  const [feedbackText, setFeedbackText] = useState('');

  const handleSubmit = () => {
    if (!feedbackText.trim()) return; // Just exit and do nothing
    if (onSendFeedback) {
      onSendFeedback(messageId, feedbackType, feedbackText.trim());
    }
    onClose();
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10,
      }}
    >
      <Box
        sx={{
          bgcolor: 'background.paper',
          p: 4,
          borderRadius: 2,
          boxShadow: 24,
          width: 380,
        }}
      >
        <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
          Feedback
        </Typography>
        <TextField
          multiline
          fullWidth
          rows={4}
          placeholder="Please share your comments..."
          value={feedbackText}
          onChange={(e) => setFeedbackText(e.target.value)}
          sx={{ mb: 2 }}
          inputProps={{
            maxLength: 250, // Set the maximum number of characters here
          }}
        />
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          {/* <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button> */}
          <Button variant="contained" onClick={handleSubmit}>
            Submit Feedback
          </Button>
        </Stack>
      </Box>
    </Box>
  );
};

export default FeedbackPopup;
